<template>
  <span 
    v-if="enable"
    class="hidden w-0 h-0"
  />
</template>

<script>
import { driver } from 'driver.js'
import 'driver.js/dist/driver.css'
import { computed, watch } from 'vue'
import { useWindowSize } from '@vueuse/core'
import { $t } from 'nette-base-module/js/vuei18next'
import { showDriver, autoplayScenarios, driverAvailableSteps, driverAutoplaySteps, viewedAutoplayScenariosIds, elements } from './AwDriverContext'
import NetteAjax from 'nette-base-module/js/nette/NetteAjax'
import $ from 'cash-dom'


export default {
  setup() {
    let driverObj = null
    let steps = null
    const { width } = useWindowSize()
    
    const enable = computed(() => {
      return width.value >= 768
    })

    const getProgressOffset = (currentStep) => {      
      const progress = currentStep / steps.length
      const circumference = 2 * Math.PI * 45
      return circumference * (1 - progress) * -1
    }

    const customHTML = {
      progressCircle: (currentStep) => {
        if (currentStep === steps.length) {
          return `
            <div class="progress-circle progress-circle-last">
              <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 50 50">
                <circle fill="currentColor" cx="25" cy="25" r="25"/>
                <path fill="white" d="M21.6,34.4l15.6-15.3l-3.4-3.4L21.6,27.8l-5.3-5.6l-3.4,3.4L21.6,34.4z"/>
              </svg>
            </div>
          `
        }

        return `
          <div class="progress-circle">
            <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 100 100">
              <circle
                class="stroke-current"
                cx="50"
                cy="50"
                r="45"
                stroke-width="10"
                fill="none"
              />
              <circle
                class="stroke-current"
                cx="50"
                cy="50"
                r="45"
                stroke-width="10"
                fill="none"
                stroke-dasharray="${2 * Math.PI * 45}"
                stroke-dashoffset="${getProgressOffset(currentStep)}"
                stroke-linecap="round"
                transform="rotate(-90 50 50)"
                style="transition: stroke-dashoffset 0.5s"
              />
            </svg>
          </div>
        `
      },
      previousButton:`
        <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20" class="driver-popover-prev-btn">
          <path fill="currentColor" d="m12 15-5-5 5-5 1.062 1.062L9.125 10l3.937 3.938Z"/>
        </svg>
        <span class="driver-popover-prev-btn">
          ${ $t('Previous') }
        </span>
      `,
      nextButton:(currentStep) => {
        if (currentStep === steps.length) {
          return `
            <span class="driver-popover-next-btn">
              ${ $t('Done') }
            </span>
          `
        }

        return `
          <span class="driver-popover-next-btn">
            ${ $t('Next') }
          </span>
          <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20" class="driver-popover-next-btn">
            <path fill="currentColor" d="m8 15-1.062-1.062L10.875 10 6.938 6.062 8 5l5 5Z"/>
          </svg>
        `
      },
      arrow: `
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="22" viewBox="0 0 32 22">
          <path fill="currentColor" d="M19.3691 19.7358C17.7957 22.1942 14.2043 22.1942 12.6309 19.7358L-9.43274e-07 0L32 -1.39876e-06L19.3691 19.7358Z"/>
        </svg>
      `,
    }

    const defineTour = () => {
      driverObj = driver({
        showProgress: true,
        onPopoverRender: (popover, { config, state }) => {
          // console.log('onPopoverRender', driverObj.value)
          // console.log('onPopoverRender', popover, config, state)

          config.stageRadius = 20
          config.disableButtons = ["close"]

          if (popover.title) {
            popover.title.innerHTML += customHTML.progressCircle(state.activeIndex + 1)
          }

          if (popover.footerButtons) {
            const prevBtn = popover.footerButtons.querySelector('.driver-popover-prev-btn')
            prevBtn.innerHTML = customHTML.previousButton

            const nextBtn = popover.footerButtons.querySelector('.driver-popover-next-btn')
            nextBtn.innerHTML = customHTML.nextButton(state.activeIndex + 1)
          }

          if (popover.arrow) {
            popover.arrow.innerHTML = customHTML.arrow
          }
        },
        onDestroyed: () => {
          // WIP, API request, post viewLinks
          autoplayScenarios.value.forEach(scenario => {
            viewedAutoplayScenariosIds.add(scenario.id)

            NetteAjax.ajax({
              url: scenario.view_link,
              off: ['vue-render', 'vue-router']
            })
          })
          showDriver.value = false
        },
        steps,
      })
    }

    let tmt = null
    const startTour = () => {
      clearTimeout(tmt)
      tmt = setTimeout(() => {
        steps = JSON.parse(JSON.stringify(showDriver.value === 'auto' ? driverAutoplaySteps.value : driverAvailableSteps.value))
        steps.forEach((step, idx) => {
          if (steps[idx + 1] && steps[idx + 1].toggle__tooltip_element_id && elements.has(steps[idx + 1].toggle__tooltip_element_id)) { // next step has toggler
            step.popover.onNextClick = function (/*element, step, options*/) {
              $(`[data-driver-element="${steps[idx + 1].toggle__tooltip_element_id}"]`).trigger('click')
              setTimeout(() => {
                driverObj.moveNext()
              }, 300)
            }
          } else if (step.toggle__tooltip_element_id && elements.has(step.toggle__tooltip_element_id) /*&& !steps[idx + 1]*/) {// current step has toggle and is last
            step.onDeselected = function () {
              $(`[data-driver-element="${step.toggle__tooltip_element_id}"]`).trigger('click')
            }
          }

          // predchozi
          if (idx > 0 && steps[idx - 1] && steps[idx - 1].toggle__tooltip_element_id && elements.has(steps[idx - 1].toggle__tooltip_element_id)) { // prev step has toggler
            step.popover.onPrevClick = function (/*element, step, options*/) {
              $(`[data-driver-element="${steps[idx - 1].toggle__tooltip_element_id}"]`).trigger('click')
              setTimeout(() => {
                driverObj.movePrevious()
              }, 300)
            }
          }
        })

        defineTour()
        driverObj.drive()
      }, 500)
    }

    watch(
      [
        showDriver,
        enable,
      ],
      () => {
        if (showDriver.value && enable.value) {
          if (driverObj === null || !driverObj.isActive()) {
            startTour()
          }
        }

        if (!enable.value && driverObj?.isActive()) {
          driverObj.destroy()
        }
      },
      { immediate: true }
    )

    return {
      enable
    }
  },
}
</script>

<style lang="scss">
.driver-popover {
  @apply rounded-3xl;

  * {
    font-family: Inter var, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  }

  .progress-circle {
    svg {
      margin-top: -10px;
    }

    svg circle:first-child {
      @apply text-gray-300;
    }

    svg circle:last-child {
      @apply text-bc-blue;
    }
  }

  .progress-circle-last {
    svg circle:first-child {
      @apply text-bc-blue;
    }
  }
}

.driver-popover-close-btn {
  // @apply text-xl;
  // top: 5px;
  // right: 5px;
  display: none !important;
}

.driver-popover-title {
  @apply text-2xl flex flex-row justify-between;
  display: flex !important;
}

.driver-popover-description {
  @apply text-base text-gray-400;
}

.driver-popover-footer {
  @apply mt-6;
}

.driver-popover-navigation-btns {
  button {
    @apply py-2 px-4 no-underline rounded-3xl cursor-pointer border-none items-center;
    text-shadow: none;
    display: flex !important;

    span {
      @apply text-sm;
    }

    svg {
      @apply w-5 h-5;
    }

    &:hover {
      transform: translateY(-2px);
    }

    &:disabled {
      display: none !important;
    }
  }

  button.driver-popover-prev-btn {
    @apply text-base text-gray-300 bg-transparent;

    svg {
      margin-right: -1px;
      margin-left: -7px;
    }

    &:hover {
      @apply bg-transparent;
    }
  }

  button.driver-popover-next-btn {
    @apply bg-bc-blue text-white;

    &:hover {
      @apply bg-bc-blue;
    }

    svg {
      margin-right: -7px;
      margin-left: -1px;
    }
  }
}

.driver-popover-arrow {
  @apply border-none text-white;

  svg {
    @apply w-8 h-8;
  }
}

.driver-popover-arrow-side-top {
  top: calc(100% - 7px);
  border-right-color: transparent;
  border-bottom-color: transparent;
  border-left-color: transparent;
}

.driver-popover-arrow-side-bottom {
  bottom: calc(100% - 7px);
  border-right-color: transparent;
  border-top-color: transparent;
  border-left-color: transparent;

  svg {
    transform: rotate(180deg);
  }
}

.driver-popover-arrow-side-left {
  left: calc(100% - 7px);
  border-right-color: transparent;
  border-bottom-color: transparent;
  border-top-color: transparent;

  svg {
    transform: rotate(-90deg);
  }
}

.driver-popover-arrow-side-right {
  right: calc(100% - 7px);
  border-top-color: transparent;
  border-bottom-color: transparent;
  border-left-color: transparent;

  svg {
    transform: rotate(90deg);
  }
}
</style>
